<mat-icon *ngIf="!data.withoutIcon">info</mat-icon>
<span class="msg" *ngIf="data.translate">
  {{ data.msg | translate }}
</span>
<span class="msg" *ngIf="!data.translate">
  {{ data.msg }}
</span>
<span class="d-block close-icon pl-2" [inlineSVG]="'/icons/no-stroke-icon-close.svg'" (click)="close()"></span>
